
import { Component, Vue } from 'vue-property-decorator'
import LogoFooter from '@/components/common/footer/LogoFooter.vue'
import CopyrightFooter from '@/components/common/footer/CopyrightFooter.vue'
import MenuFooter from '@/components/common/footer/MenuFooter.vue'
import AddressFooter from '@/components/common/footer/AddressFooter.vue'
import LinksFooter from '@/components/common/footer/LinksFooter.vue'
import WatermarksFooter from '@/components/common/footer/WatermarksFooter.vue'

@Component({
  name: 'Footer',
  components: {
    LogoFooter,
    CopyrightFooter,
    MenuFooter,
    AddressFooter,
    LinksFooter,
    WatermarksFooter
  }
})
export default class Footer extends Vue {
  get menu() {
    return [
      { id: '1', href: '/', text: 'home' },
      { id: '2', href: 'https://intercom.help/scholarshipowl/en/', text: 'help' },
      { id: '3', href: '/faq', text: 'faq' },
      { id: '4', href: '/press', text: 'press' },
      { id: '5', href: 'https://careers.scholarshipowl.com', text: 'jobs', target: '_blank' },
      { id: '6', href: '/contact', text: 'contact' }
    ]
  }
}
